import React, { memo, useEffect, useState } from 'react'
import { Checkbox, FormControlLabel, Grid } from '@mui/material'
// import { Trans } from 'react-i18next'

import CustomDialog from '../shared/customDialog/CustomDialog'
import HeadingText from '../shared/text/HeadingText'
import CustomAlert from '../shared/CustomAlert/CustomAlert'
import { formatCurrency, formatCurrencyShort } from '../../util/numbers.helpers'
import Text from '../shared/text/Text'
import { MAIN_PROFILE_DISPATCH } from '../../store/reducers/main'
import { transWithArgs } from '../../util/validation.helpers'
import {
  CURRENCIES,
  CLAIM_CURRENCY_TYPE,
  QUEST_TAP_POOL_ID
} from '../../constants/app'
import CustomButton from '../shared/buttons/CustomButton'
import { qbxToVir } from '../../util/claim.helpers'

const ClaimTapPopup = ({
  t,
  onClose,
  onSubmit,
  mainProfile: { error, claimTapProcessing, claimQBXProcessing },
  available,
  onClaimTap,
  dispatchAction,
  id,
  choice = ''
}) => {
  if (id !== QUEST_TAP_POOL_ID) {
    choice = CLAIM_CURRENCY_TYPE.QBX
  }
  const label = buildLabelByChoice(t, choice)
  const [prevAvailable, setPrevAvailable] = useState()
  useEffect(() => {
    if (claimQBXProcessing) {
      setPrevAvailable(available)
    }
  }, [claimQBXProcessing])
  const availableValue = claimQBXProcessing ? prevAvailable : available
  const claimQBXError = error[MAIN_PROFILE_DISPATCH.CLAIM_QBX]
  const claimTapError = error[MAIN_PROFILE_DISPATCH.CLAIM_TAP]
  const processing = claimTapProcessing || claimQBXProcessing
  const txnErr = claimQBXError || claimTapError
  const [checked, setChecked] = useState(false || Boolean(choice))
  const handleChange = (event) => {
    setChecked(event.target.checked)
  }
  return (
    <CustomDialog
      isForm
      title={t('home.claim-tap-title', { label })}
      description={t('home.claim-tap-desc', { label })}
      open
      onClose={onClose}
      cancelProps={{
        label: t('staking.stay-vested-and-get-staking'),
        autoWidth: true
      }}
      maxWidth='md'
      body={
        <Grid container spacing={3} alignItems='center'>
          {!choice && (
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked}
                    onChange={handleChange}
                    size='medium'
                  />
                }
                label={t('staking.understand-claiming')}
              />
            </Grid>
          )}
          {(!choice || choice === CLAIM_CURRENCY_TYPE.QBX) && (
            <>
              <Grid item xs={12} md={8}>
                <Text label={t('home.claim')} fontWeight={700} />
                <HeadingText
                  label={`${formatCurrencyShort(availableValue)} ${CURRENCIES.DEFAULT}`}
                  helpText={formatCurrency(availableValue)}
                  isLargeFont
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomButton
                  onClick={() => onClaimTap(CLAIM_CURRENCY_TYPE.QBX)}
                  label={t('home.claim')}
                  disabled={processing || !checked}
                />
              </Grid>
            </>
          )}
          {(!choice || choice === CLAIM_CURRENCY_TYPE.VIR) && (
            <>
              <Grid item xs={12} md={8}>
                <Text label={t('staking.claim-vir')} fontWeight={700} />
                <HeadingText label={qbxToVir(availableValue)} isLargeFont />
                <Text label={t('staking.receive-vir-note')} />
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomButton
                  onClick={() => onClaimTap(CLAIM_CURRENCY_TYPE.VIR)}
                  label={t('staking.claim-vir')}
                  disabled={processing || !checked}
                />
              </Grid>
            </>
          )}
          {(processing || txnErr) && (
            <Grid item xs={12}>
              <CustomAlert
                info={processing && t('home.transaction-processing')}
                error={txnErr && transWithArgs(t, txnErr)}
                onTimeOut={
                  processing
                    ? () => {
                        dispatchAction(
                          MAIN_PROFILE_DISPATCH.CLAIM_QBX_PROCESSING,
                          false
                        )
                        dispatchAction(
                          MAIN_PROFILE_DISPATCH.CLAIM_TAP_PROCESSING,
                          false
                        )
                        dispatchAction(MAIN_PROFILE_DISPATCH.CLAIMED_VIR, null)
                        dispatchAction(
                          MAIN_PROFILE_DISPATCH.QBX_TXN_PAYLOAD,
                          null
                        )
                      }
                    : null
                }
              />
            </Grid>
          )}
        </Grid>
        // <Grid container spacing={2}>
        //   <Grid item xs={12}>
        //     <HeadingText
        //       label={`${formatCurrencyShort(availableValue)} ${CURRENCIES.DEFAULT}`}
        //       isLargeFont
        //       helpText={formatCurrency(availableValue)}
        //     />
        //   </Grid>
        //   <Grid item xs={12}>
        //     <Text
        //       variant='body1'
        //       label={<Trans i18nKey='home.claimed-note' />}
        //     />
        //   </Grid>
        //   {(claimTapProcessing || claimTapError) && (
        //     <Grid item xs={12}>
        //       <CustomAlert
        //         info={claimTapProcessing && t('home.transaction-processing')}
        //         error={claimTapError && transWithArgs(t, claimTapError)}
        //         onTimeOut={
        //           claimTapProcessing
        //             ? () => {
        //                 dispatchAction(
        //                   MAIN_PROFILE_DISPATCH.CLAIM_QBX_PROCESSING,
        //                   false
        //                 )
        //               }
        //             : null
        //         }
        //       />
        //     </Grid>
        //   )}
        // </Grid>
      }
      onSubmit={onSubmit}
      t={t}
    />
  )
}

export default memo(ClaimTapPopup)

const buildLabelByChoice = (t, choice) => {
  if (choice === CLAIM_CURRENCY_TYPE.QBX) {
    return CURRENCIES.QBX
  } else if (choice === CLAIM_CURRENCY_TYPE.VIR) {
    return CURRENCIES.VIR
  } else {
    return t('home.qbx-or-vir')
  }
}
